<template>
  <div class="variety-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newVarietyForm" :model="varietyModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="varietyModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="全称" prop="fullName">
            <Input v-model="varietyModel.fullName" placeholder="输入全称" />
          </FormItem>
          <FormItem label="折算系数" prop="coefficient">
            <InputNumber v-model="varietyModel.coefficient" :max="1" :min="0" :step="0.1" placeholder="0~1" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="varietyModel.type">
              <Option value="支付类">支付类</Option>
              <Option value="履约类">履约类</Option>
            </Select>
          </FormItem>
          <FormItem label="全局" prop="isGlobal">
            <i-switch v-model="varietyModel.isGlobal" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'variety-new',
  props: {
  },
  data () {
    return {
      loading: false,
      varietyModel: {
        name: null,
        fullName: null,
        coefficient: 1,
        isGlobal: true,
        type: '支付类'
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        fullName: [
          { required: true, message: '请填写全称', trigger: 'blur' }
        ],
        coefficient: [
          { required: true, type: 'number', message: '请填写折算系数', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async submit () {
      this.$refs.newVarietyForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Guarantee.addGuaranteeVariety(this.varietyModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.varietyModel= {
                name: null,
                fullName: null,
                coefficient: 1,
                isGlobal: true,
                type: '支付类'
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
